"use strict";

exports.__esModule = true;
exports.DashboardListAccoridanView = DashboardListAccoridanView;
var _react = _interopRequireWildcard(require("react"));
var _System = require("../../../System");
var _DashboardThumbnail = require("../DashboardThumbnail");
var _Core = require("../../Core");
var _DashboardList = require("./DashboardList");
var _styledComponents = require("./utils/styledComponents");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Profile = require("../../Profile");
var _useAdministrativeTenant = _interopRequireDefault(require("../../AdministrativeTenant/Hooks/useAdministrativeTenant"));
var _constants = require("../../constants");
var _excluded = ["onItemClick", "items", "selectedIds", "tags"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function renderDashboard(item, selectedIds, onItemClick) {
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.DashboardListItem, {
    key: item.id,
    "data-testid": "DashboardListItem",
    to: (0, _System.getScreenURL)("Dashboard", item),
    "aria-selected": selectedIds.includes(item.id),
    onClick: typeof onItemClick !== "function" ? undefined : function (e) {
      e.preventDefault();
      onItemClick(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(_DashboardThumbnail.DashboardThumbnail, {
    width: 140,
    height: 105,
    dashboard: item
  }), /*#__PURE__*/_react["default"].createElement(_styledComponents.DashboardListItemLabel, {
    "data-testid": "DashboardListItem.label"
  }, item.name));
}

/**
 * Shows a list of dashboards.
 */
function DashboardListAccoridanView(props) {
  var isAdministrativeTenant = (0, _useAdministrativeTenant["default"])();
  var _useState = (0, _react.useState)([_constants.TAG_UNTAGGED]),
    openItems = _useState[0],
    setOpenItems = _useState[1];
  var _useContext = (0, _react.useContext)(_Profile.ProfileContext),
    userRolesDetails = _useContext.userRolesDetails,
    user = _useContext.user;
  function renderTag(tag) {
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.DashboardListItemHeading, {
      "data-testid": "DashboardAccordianItem.Heading"
    }, tag);
  }
  function renderDashboardsForTag(tag) {
    if (dashboardsSortedByTags[tag]) {
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.DashboardListAccoridanViewContainer, null, dashboardsSortedByTags[tag].map(function (dashboard) {
        return renderDashboard(dashboard, selectedIds, onItemClick);
      }));
    }
    return null;
  }
  function isItemOpen(item) {
    return openItems.includes(item);
  }
  function toggleItemOpen(item) {
    if (isItemOpen(item)) {
      setOpenItems(openItems.filter(function (itemName) {
        return itemName !== item;
      }));
    } else {
      setOpenItems([].concat(openItems, [item]));
    }
  }
  var onItemClick = props.onItemClick,
    items = props.items,
    _props$selectedIds = props.selectedIds,
    selectedIds = _props$selectedIds === void 0 ? [] : _props$selectedIds,
    tags = props.tags,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var dashboardsSortedByTags;
  var tagList;
  var filteredItems = items;
  if (!isAdministrativeTenant) {
    filteredItems = (0, _ConfigurableLayout.filterLayoutElementsByUserRoles)(userRolesDetails, filteredItems);
    filteredItems = (0, _ConfigurableLayout.filterLayoutElementsByUser)(user, filteredItems);
  }
  if (tags) {
    dashboardsSortedByTags = filteredItems.reduce(function (acc, item) {
      var doesItemHaveTag = false;
      tags.forEach(function (tag) {
        if (item.tags && item.tags.includes(tag)) {
          doesItemHaveTag = true;
          acc[tag] = acc[tag] ? [].concat(acc[tag], [item]) : [item];
        }
      });
      if (!doesItemHaveTag) {
        acc[_constants.TAG_UNTAGGED] = acc[_constants.TAG_UNTAGGED] ? [].concat(acc[_constants.TAG_UNTAGGED], [item]) : [item];
      }
      return acc;
    }, {});
    tagList = Object.keys(dashboardsSortedByTags).sort().filter(function (tag) {
      return tag !== _constants.TAG_UNTAGGED;
    });
    tagList.push(_constants.TAG_UNTAGGED);
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      style: {
        width: "100%",
        height: "100%"
      },
      "data-testid": "DashboardListAccordianView"
    }, extra), /*#__PURE__*/_react["default"].createElement(_Core.Accordian, {
      items: tagList,
      renderItem: renderTag,
      renderItemContent: renderDashboardsForTag,
      getKey: function getKey(tag) {
        return tag;
      },
      isItemOpen: isItemOpen,
      toggleItemOpen: toggleItemOpen,
      itemWidth: "100%",
      expandedViewMaxHeight: "350px"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_DashboardList.DashboardList, props);
}